import { map, prop } from 'ramda';

export const getVariablesForRules = map((v) => ({ type: prop('type', v), key: prop('name', v) }));
